class ObjectDataList {
    constructor(type, list) {
        this.type = type;
        this._list = list || [];
    }

    getType() {
        return this.type;
    }

    getAll() {
        return this._list;
    }

    hasData() {
        return this.getAll().length > 0;
    }

    isEmpty() {
        const all = this.getAll();
        return !all.length || all.length < 1;
    }

    find(callback) {
        return this.getAll().find(callback);
    }

    filter(callback) {
        return this.getAll().filter(callback);
    }

    some(callback) {
        return this.getAll().some(callback);
    }

    sort(callback) {
        return this.getAll().sort(callback);
    }
}

export default ObjectDataList;